module.exports = "<div id=\"supportOverview\">\n    <support-case-banner></support-case-banner>\n    <support-case-history-table></support-case-history-table>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./modules/support/components/support-overview/supportOverview.component.html
// module id = 751
// module chunks = 0